var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconProject2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 196,
    height: 194,
    viewBox: "0 0 196 194",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.3282 14.0866C63.5407 5.97005 80.0975 1.33203 97.6799 1.33203C151.16 1.33203 194.53 44.2337 194.53 97.136C194.53 150.038 151.16 192.94 97.6799 192.94C44.2 192.94 0.830078 150.038 0.830078 97.136C0.830078 76.8447 7.13044 58.1477 17.9729 42.6393",
    stroke: "#1D4289",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M94.4572 192.94C80.5378 192.505 67.351 189.171 55.4828 183.519C38.0469 175.112 23.3949 161.633 13.7246 145.11H54.7502C54.8968 145.835 55.1898 146.56 55.4828 147.429C57.9737 155.401 61.0506 162.648 64.7136 168.88C72.6257 182.649 83.0286 191.635 94.4572 192.94Z",
    fill: "#8CA0C4",
    stroke: "#1D4289",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M181.344 145.11C176.216 154.096 169.476 162.068 161.857 168.88C155.263 174.678 147.791 179.75 139.732 183.519C127.718 189.171 114.384 192.65 100.318 192.94C111.747 191.635 122.15 182.794 130.208 168.88C133.871 162.358 137.095 154.821 139.732 146.27C139.879 145.835 140.025 145.545 140.025 145.11H181.344Z",
    fill: "#8CA0C4",
    stroke: "#1D4289",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M139.876 145.11C139.73 145.545 139.583 145.835 139.583 146.27C136.946 154.676 133.722 162.358 130.059 168.88H64.7114C61.1949 162.648 57.9715 155.401 55.4806 147.429C55.1876 146.705 55.0411 145.98 54.748 145.11H139.876Z",
    fill: "#8CA0C4",
    stroke: "#1D4289",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M130.065 168.735C122.006 182.65 111.603 191.636 100.175 192.795C99.2955 192.795 98.4164 192.795 97.5373 192.795C96.5117 192.795 95.486 192.795 94.4604 192.795C83.0318 191.491 72.6289 182.65 64.7168 168.735H130.065Z",
    fill: "#8CA0C4",
    stroke: "#1D4289",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M161.709 168.736H130.061H161.709Z",
    fill: "#8CA0C4"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M161.709 168.736H130.061",
    stroke: "#1D4289",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M64.7166 168.736H33.6543",
    stroke: "#1D4289",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M127.422 123.37H110.279V137.284H127.422V123.37Z",
    fill: "white",
    stroke: "#1D4289",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M139.881 137.284H85.2285V144.966H139.881V137.284Z",
    fill: "white",
    stroke: "#1D4289",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M166.543 61.6265H69.6934V114.094H166.543V61.6265Z",
    fill: "white",
    stroke: "#1D4289",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M166.543 114.094H69.6934V123.37H166.543V114.094Z",
    fill: "white",
    stroke: "#1D4289",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M130.503 30.7549H77.4629V108.007H130.503V30.7549Z",
    fill: "white",
    stroke: "#1D4289",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M66.0311 75.106C53.1373 75.106 42.5879 85.5414 42.5879 98.2959C42.5879 111.05 53.1373 121.486 66.0311 121.486C78.9249 121.486 89.4743 111.05 89.4743 98.2959C89.4743 85.5414 79.0714 75.106 66.0311 75.106ZM66.0311 113.804C57.3864 113.804 50.3535 106.847 50.3535 98.2959C50.3535 89.7446 57.3864 82.7876 66.0311 82.7876C74.6758 82.7876 81.7088 89.7446 81.7088 98.2959C81.7088 106.847 74.6758 113.804 66.0311 113.804Z",
    fill: "#8CA0C4",
    stroke: "#1D4289",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M102.807 98.731H29.4004V145.112H102.807V98.731Z",
    fill: "#F6BE00",
    stroke: "#1D4289",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M102.807 98.731H29.4004V120.472H102.807V98.731Z",
    fill: "#8CA0C4",
    stroke: "#1D4289",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M102.807 120.327H29.4004V144.967H102.807V120.327Z",
    fill: "white",
    stroke: "#1D4289",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M72.3351 114.239H59.8809V126.559H72.3351V114.239Z",
    fill: "#F6BE00",
    stroke: "#1D4289",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M119.51 52.3506C119.51 60.9019 112.477 67.8589 103.832 67.8589C95.1873 67.8589 88.1543 60.9019 88.1543 52.3506C88.1543 47.8575 90.0591 43.7993 93.136 41.0455C95.9199 38.4366 99.7294 36.8423 103.832 36.8423C108.081 36.8423 112.037 38.5815 114.821 41.3354C117.751 44.2341 119.51 48.1474 119.51 52.3506Z",
    fill: "#F6BE00",
    stroke: "#1D4289",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M114.82 41.4813L104.124 52.0616L93.1348 41.1914C95.9187 38.5826 99.7282 36.9883 103.831 36.9883C108.226 36.9883 112.036 38.7275 114.82 41.4813Z",
    fill: "#8CA0C4",
    stroke: "#1D4289",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M110.135 59.8867L135.336 84.8163H161.856",
    stroke: "#1D4289",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M160.246 67.5684H136.803V78.5837H160.246V67.5684Z",
    fill: "#F6BE00",
    stroke: "#1D4289",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M135.338 91.0479H161.858",
    stroke: "#1D4289",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M88.3027 73.9463H119.658",
    stroke: "#1D4289",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M88.3027 80.1782H119.658",
    stroke: "#1D4289",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M97.8262 86.4102H119.658",
    stroke: "#1D4289",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M97.8262 92.498H119.658",
    stroke: "#1D4289",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M135.338 97.1367H161.858",
    stroke: "#1D4289",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M135.338 103.368H161.858",
    stroke: "#1D4289",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2058 39.8847C37.5637 39.8847 45.9605 31.5786 45.9605 21.3325C45.9605 11.0864 37.5637 2.78027 27.2058 2.78027C16.8479 2.78027 8.45117 11.0864 8.45117 21.3325C8.45117 31.5786 16.8479 39.8847 27.2058 39.8847Z",
    fill: "#F6BE00",
    stroke: "#1D4289",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8574 19.4477L25.4508 25.9699L41.7145 9.88184",
    stroke: "#1D4289",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconProject2);
export default __webpack_public_path__ + "static/media/icon-project2.3a140e5c1c3e852aa7c2ad73c6ac5ade.svg";
export { ForwardRef as ReactComponent };